import ReactPaginate from "react-paginate"
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io"
import { FiArrowRightCircle, FiArrowLeftCircle } from "react-icons/fi"

import React, { useState } from "react"
const PaginateComponent = ({
  totalPages,
  currentPage,
  setCurrentPage,
  perPage,
}: {
  totalPages: number
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  perPage: number
}) => {
  const [check, setCheck] = useState(1)
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  // const [itemOffset, setItemOffset] = useState(0)

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  // const endOffset = itemOffset + itemsPerPage
  // console.log(`Loading items from ${itemOffset} to ${endOffset}`)
  // const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(totalPages / perPage)

  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * perPage) % totalPages
    // console.log(newOffset)
    // console.log(
    //   `User requested page number ${
    //     event.selected + 1
    //   }, which is offset ${newOffset}`
    // )
    setCheck(event.selected + 1)
    setCurrentPage(newOffset)
  }
  // console.log(currentPage, pageCount)
  // console.log(itemOffset)

  // const handlePageClick = async ({ selected }: { selected: number }) => {

  //   setCurrentPage(selected + 1)

  // }
  return (
    <div>
      <ReactPaginate
        breakLabel={<span className=" mr-3 text-white">...</span>}
        nextLabel={
          <span>
            <FiArrowRightCircle
            
              // size={20}
              className={` text-[25px] ${
                check === pageCount ? "text-gray-600" : "text-white"
              }  `}
            />
          </span>
        }
        onPageChange={handlePageClick}
        pageRangeDisplayed={4}
        pageCount={pageCount}
        marginPagesDisplayed={1}
        previousLabel={
          <span>
            <FiArrowLeftCircle
              className={` text-[25px] ${
                currentPage === 0 ? "text-gray-600" : "text-white"
              }  `}
            />
          </span>
        }
        renderOnZeroPageCount={null}
        containerClassName=" flex items-center justify-center mt-4 mb-4"
        pageClassName=" block text-[18px]  w-6 h-6 flex justify-center items-center rounded-md hover:bg-gray-400 mr-1 font-varela text-[0.75rem] text-white"
        activeClassName="bg-white text-black"
        activeLinkClassName="text-black flex items-center justify-center w-full h-full"
        nextClassName="ml-2"
        previousClassName=" mr-2"
      />
    </div>
  )
}

export default PaginateComponent
